.loginPage,
.signup,
.forgotPassword,
.forgotPassword {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.loginHeading {
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0.1px;
  font-family: "Poppins", sans-serif;
  margin-bottom: 40px;
  margin-top: 0px;
  color: #243460;
}
.loginHeading + p {
  font-family: "Poppins", sans-serif;
  margin-bottom: 45px;
  line-height: 24px;
  margin-top: 16px;
  color: #243460;
}
.container {
  max-width: 1440px;
  margin: auto;
  min-height: 70vh;
  font-family: "Poppins", sans-serif;
}

.headerMobile {
  padding: 16px;
}

/*.logoLight img {
  width: 150px;
}*/

.primaryBtn {
  padding: 8px 12px;
  background: #243460;
  color: #ffffff;
  border-radius: 2px;
  font-weight: 600;
  border: 2px solid #243460;
  transition: 0.5s all;
  border-radius: 6px;
}

.primaryBtn:hover {
  border-color: #fe7165;
}

.signUpBtn {
  font-size: 14px;
  padding: 8px 60px;
}
.signUpText {
  font-size: 14px;
  text-align: center;
  font-size: 14px;
  line-height: 28px;
  color: #243060;
  font-weight: 600;
  margin-right: 20px;
}
.signUpText:hover {
  color: #fe7165;
}
.leftContent {
  border-top-right-radius: 100px;
  overflow: hidden;
}

.formContainer {
  padding: 16px;
}
.content {
  padding: 40px 16px;
}
.seperatorLine {
  flex: 1;
  height: 1px;
  background-color: #243460;
}

.seperatorText {
  padding: 0px 38px;
  color: #3b3b3b;
  font-weight: 400;
}

.loginForm input {
  color: #3b3b3b;
  padding: 10px 12px;
  border-radius: 0px;
  background-color: #ffffff;
  outline: none;
  font-family: "Poppins", sans-serif;
  margin-top: 10px;
  border: 1px solid #24346066;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  font-weight: 500;
  text-align: justify;
  border-radius: 6px;
}
.loginForm input::placeholder {
  color: #3b3b3b99;
  font-weight: 300;
}
.loginForm input:hover {
  border-color: #243460;
}
.loginForm input:active,
.loginForm input:focus {
  border-color: #243460;
  border-width: 1.5px;
  padding: 9.5px 12px;
}
.loginForm label {
  color: #3b3b3b;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-family: "Poppins", sans-serif;
}
.loginForm label:hover ~ input {
  border: 1px solid #24346066;
}
label.errorLabels {
  color: #ff0000;
  font-size: 12px;
  margin-top: 4px;
  opacity: 70%;
  line-height: 16px;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  opacity: 1;
}

.errorLabelForm {
  color: #ff0000;
  font-size: 14px;
  margin-top: 2px;
  opacity: 100%;
  margin-left: 4px;
  opacity: 1;
}

.emailRow,
.passwordRow,
.rememberMeRow {
  margin-bottom: 24px;
}
.passwordEye svg,
.passwordEye img {
  width: 20px;
  margin-top: 7px;
}

.loginForm input:focus {
  outline: none;
}

.loginBtn {
  font-family: "Poppins", sans-serif;
  width: 100%;
  cursor: pointer;
  padding: 17px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 8px;
  margin-top: 8px;
  text-transform: uppercase;
}
.socialSection {
  margin: auto;
  margin-top: 22px;
}
.googleIcon {
  position: relative;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.googleIframeOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.socialIcons {
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.contentContaienr {
  width: 100%;
  flex-grow: 1;
}
.content {
  flex: 1;
  max-width: 100%;
}
.formContainer {
  width: 100%;
  max-width: 472px;
  margin: 0 auto;
}

.contentContaienr .leftContent {
  background-color: #243460;
  position: relative;
  width: 42.2%;
}
.leftContent img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 1;
}

.desktopHeader {
  position: relative;
  height: 100px;
}
.dontHaveAccount {
  color: #3b3b3b;
  font-weight: 600;
  font-size: 14px;
  margin-right: 20px;
  cursor: pointer;
}
.footer {
  background-color: #243460;
  padding: 32px 20px;
  color: white;
}
.footerContent {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
}
.footerText {
  font-size: 12px;
}
.footerLogo img {
  width: 150px;
}

.heading {
  font-weight: 600;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  color: #243460;
}
.subHeading {
  font-size: 16px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  line-height: 24px;
  margin-bottom: 44px;
  color: #243460;
}
.normalLink {
  color: #243460;
}
.normalLink:hover {
  color: #fe7165;
  text-decoration: none;
}
.leftContent img {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  object-fit: cover;
}
.logoDark img {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 200px;
  object-fit: contain;
  height: auto;
}
@media screen and (min-width: 744px) {
  .footerLogo img {
    width: 150px;
  }
  .leftContent {
    max-height: 100%;
  }
  .contentContaienr {
    width: 100%;
  }
  .desktopHeader {
    height: 100px;
    padding-right: 32px;
  }

  .content {
    padding: 0px 0px 20px 0px;
  }
  .leftContent {
    width: 40%;
  }
}
@media screen and (max-width: 370px) {
  .signUpBtn {
    padding: 8px 28px;
  }
}
.inputMessage {
  font-size: 14px;
  margin-top: 10px;
  color: #000000;
}

@media screen and (min-width: 1028px) {
}

@media screen and (min-width: 1280px) {
  .leftContent {
    width: 50%;
  }
}
@media screen and (max-width: 1279px) {
  .leftContent img {
    object-fit: cover;
    min-height: unset;
    max-height: unset;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.nopadding {
  padding: 0;
}

.iframecontainer {
  padding-top: 10px;
  max-width: 450px;
  margin: 0 auto;
}
.iframecontainer {
  width: 90%;
  max-width: 100%;
}
@media screen and (max-width: 1024px) {
  .contentContaienr .leftContent {
    width: 34%;
  }
  .formContainer {
    padding: 16px 20px;
  }
  .loginForm input {
    margin-top: 8px;
    padding: 11px 12px;
  }
}
@media screen and (max-width: 600px) {
  .signUpBtn {
    padding: 8px 20px;
  }
  .logoLight {
    width: 30px;
    height: 40px;
  }
  .formContainer {
    margin: 0 auto;
  }
  .content {
    padding: 0px 0px 46px 0px;
  }
  .formContainer {
    width: 100%;
    padding: 16px;
    margin: 0 auto;
  }
  .iframecontainer {
    padding: 0;
  }
  .loginForm input {
    padding: 11px 9px;
  }
}
